import { Box, styled } from '@mui/material'
import { SelectMenu } from '$common/select-menu'
import { NavigationBarChatIcon } from '$common/icons/navitation-bar-tool-box/chat'
import { NavigationBarEventIcon } from '$common/icons/navitation-bar-tool-box/event'

import { useWindowHeight } from '$func/window.react-hook'
import { t } from '$i18n'
import { openEventCreator, openForumCreator } from '$logic/wapps/business'
import { closeNavbarToolBox } from '$logic/router'
import { ArrowRightIcon } from '$common/icons'

const StyledBox = styled(Box)({
  width: '40px',
  height: '40px',
  border: '0.5px solid rgba(0, 0, 0, 0.12)',
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginLeft: '10px',
})

const getIcons = async () => {
  return [<NavigationBarEventIcon />, <NavigationBarChatIcon />].map(icon => (
    <StyledBox>{icon}</StyledBox>
  ))
}

export function ConnectivityToolsSelectMenu({
  onBack,
}: {
  onBack: () => unknown
}) {
  const windowHeight = useWindowHeight()
  return (
    <Box sx={{ backgroundColor: 'white' }}>
      <SelectMenu
        onDone={async ([wappName]) => {
          await closeNavbarToolBox()

          if (wappName === t('wapps.forum')) openForumCreator()
          if (wappName === t('wapps.event')) openEventCreator()
        }}
        headerTexts={[t('navigationBarToolBox.connectivityTools.title')]}
        HeaderIcon={ArrowRightIcon}
        onExit={onBack}
        alignOptionsCenter={false}
        optionFetchers={[async () => [t('wapps.event'), t('wapps.forum')]]}
        iconFetchers={[getIcons]}
        maxHeight={windowHeight}
      />
    </Box>
  )
}
